module.exports = __webpack_public_path__ + "img/20240830072337248ono.f8cf6498.jpg";